export function toSafeCode(value: string): string {
  return (
    value
      .replace(/([a-z])([A-Z])/g, "$1_$2")
      .replace(/[^A-Za-z0-9_ -]/g, "_")
      .trim()
      .replace(/[\s-]+/g, "_")
      .replace(/^_+|_+$/g, "")
      .toUpperCase()
      .slice(0, 80) || "UNKNOWN_ERROR"
  );
}

export function getErrorName(error: unknown): string | undefined {
  if (error instanceof DOMException || error instanceof Error) {
    return error.name || "Error";
  }
  return undefined;
}

export function getErrorMessage(error: unknown): string {
  if (error instanceof DOMException || error instanceof Error) {
    return error.message || "";
  }
  return typeof error === "string" ? error : "";
}

export function getSafeErrorCode(error: unknown, fallbackCode: string): string {
  const fallback = toSafeCode(fallbackCode || "UNKNOWN_ERROR");
  const name = getErrorName(error);
  if (!name || name === "Error") {
    return fallback;
  }
  return toSafeCode(`${fallback}_${name}`);
}
